import { Card, Space, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { AssignSecondaryCategoriesToUserPresenter } from '@webapp/modules/purchasing/features/assign-secondary-categories-to-user'
import { CatalogPermissionUserConfigListPresenter } from '@webapp/modules/purchasing/features/list-catalog-permission-user-configs'
import messages from './messages'
import { useCatalogUserAccessSection } from './useCatalogUserAccessSection'

export const CatalogUserAccessSection = () => {
  const intl = useProcurifyIntl()
  const {
    states: { selectedUser, selectedUserId },
    commands: { onSelectUser, onCancel },
  } = useCatalogUserAccessSection()

  return (
    <Space direction='horizontal' align='start' size='large'>
      <Space.Item width='30%'>
        <Card>
          <Card.Content>
            <CatalogPermissionUserConfigListPresenter
              selectedUserId={selectedUserId}
              onSelectUser={onSelectUser}
            />
          </Card.Content>
        </Card>
      </Space.Item>

      <Space.Item width='70%'>
        <Card>
          <Card.Content>
            {selectedUser !== null ? (
              <AssignSecondaryCategoriesToUserPresenter
                user={selectedUser}
                onCancel={onCancel}
              />
            ) : (
              <Space align='center' justify='center'>
                <Text>
                  {intl.formatMessage(messages.selectUserPlaceholder)}
                </Text>
              </Space>
            )}
          </Card.Content>
        </Card>
      </Space.Item>
    </Space>
  )
}

CatalogUserAccessSection.displayName = 'CatalogUserAccessSection'
